import React, { useEffect, useState } from 'react'
import { smartScheduleSelector } from '../../../../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import { useSelector } from 'react-redux';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import { useDispatch } from 'react-redux';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import CustomDropDown from '../../../../../../../Common/CustomDropDown/CustomDropDown';

const WarehouseFiltersForReports = ({themeSelected, currentWarehouseFilterSelected, setCurrentWarehouseFilterSelected, maxChars=10}) => {
    const dispatch = useDispatch();
    const userObj = useSelector(getUserSelector);
    const { selectedWarehouse } = userObj;
    const ss = useSelector(smartScheduleSelector);
    const { warehouseListForReportFilter } = ss;
    const [filterList, setFilterList] = useState([])

    useEffect(() => {
        if (selectedWarehouse && selectedWarehouse.CompanyID) {
         dispatch({type: sagaActions.GET_WAREHOUSE_BY_COMPANY_ID, payload: {"companyId": selectedWarehouse.CompanyID}})
        }
    }, [selectedWarehouse])

    useEffect(() => {
        if (warehouseListForReportFilter && warehouseListForReportFilter.length) {
     const finalList = []
  finalList.push({
          ID: null,
    name: "All Warehouse"
     })
         warehouseListForReportFilter.forEach((el) => {
  let obj = {
 ID: el.ID,
         name: el.ExternalSiteID ? `${el.ExternalSiteID} - ${el.Name}` : el.Name
    }
    finalList.push(obj)
})
            setFilterList(finalList)

         // If no warehouse filter is currently selected, pre-select the current logged-in warehouse
            if (!currentWarehouseFilterSelected) {
                const currentWH = finalList.find(el => el.ID === selectedWarehouse?.ID)
       if (currentWH) {
         setCurrentWarehouseFilterSelected(currentWH)
            }
   }
        }
    }, [warehouseListForReportFilter])

    return (
        <div>
            <CustomDropDown themeSelected={themeSelected} data={filterList} placeHolder={currentWarehouseFilterSelected?.name} onSelect={(event) => setCurrentWarehouseFilterSelected(event)} keyStr={'name'} maxChars={maxChars} />
 </div>
    )
}

export default WarehouseFiltersForReports
